//EVENTS
export const GET_EVENTS = "/events"
export const GET_EVENTS_CATEGORIES_PUBLISHED = "/eventoscategory"
export const GET_EVENTS_PUBLISHED = "/profesionales/eventos"
export const GET_EVENT_PROFILE = "/events"
export const ADD_NEW_EVENT = "/events"
export const UPDATE_EVENT = "/events"
export const DELETE_EVENT = "/events"
export const ADD_IMAGE_EVENT = '/events/upload'